import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Typography,
  Switch,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PriceCheck } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useRestaurant } from '@app/hooks/useRestaurant';
import api from '@app/api/api';
import { toast } from 'react-toastify';

export default function TaxesSettings() {
  const { t } = useTranslation();
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const { restaurant, isLoading, error, retry } = useRestaurant(restaurantId!);
  const [priceIncludesTax, setPriceIncludesTax] = useState(false);

  useEffect(() => {
    if (restaurant?.settings?.priceIncludesTax) {
      setPriceIncludesTax(restaurant.settings.priceIncludesTax);
    }
  }, [restaurant]);

  const handlePriceIncludesTaxChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newPriceIncludesTax = event.target.checked;
    setPriceIncludesTax(newPriceIncludesTax);
    try {
      await api.Restaurant.updateSettings(restaurantId!, {
        priceIncludesTax: newPriceIncludesTax,
      });
      toast.success(t('taxes.settings.update-success'));
    } catch (error) {
      toast.error(t('taxes.settings.update-error'));
      // revert the change if the API call fails
      setPriceIncludesTax(!newPriceIncludesTax);
    }
  };

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error loading restaurant settings.</p>;

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: '100%',
        mb: 1,
        px: 0,
        '& tr:last-child td': { borderBottom: 'none' },
      }}
    >
      <Table>
        <TableBody>
          <tr>
            <TableCell>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PriceCheck color="primary" />
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {t('taxes.settings.price-includes-tax')}
                </Typography>
              </Box>
            </TableCell>
            <TableCell
              align="right"
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Switch
                checked={priceIncludesTax}
                onChange={handlePriceIncludesTaxChange}
                name="priceIncludesTax"
                color="primary"
              />
            </TableCell>
          </tr>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
